import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/ui/Spinner';

export function PageLoader() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 text-[var(--fv-text-muted)]">
      <Spinner size="lg" />
      <p className="text-sm">{t('common.loading')}</p>
    </div>
  );
}
